
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSlightlycloudyDay as ObiSlightlycloudyDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-slightlycloudy-day.js';
 
 
 

 
 export const ObiSlightlycloudyDay = createComponent({
   react: React,
   tagName: 'obi-slightlycloudy-day',
   elementClass: ObiSlightlycloudyDayElement,
   events: {
     
   }
  });
 
 